<template lang="pug">
  v-content
    v-container(fluid)
      v-toolbar.elevation-1(card color='white')
        v-toolbar-title Create New {{$route.name}}
        v-spacer
        v-btn(color="green" dark v-if="$route.path == '/im-budget'" href='https://drive.google.com/drive/folders/1znvp8X3Pr7XB5fWf7GLSi52j2MUPrCfo' target="_blank") SOP IM BUDGET
        v-dialog(v-if="$route.path == '/im-budget' || $route.path == '/im-proposal-investasi'" v-model="dialog" width="900px")
          template(v-slot:activator="{ on }")
            v-btn(color="green" dark v-on="on") MLA Reference
          v-card
            v-card-text
              v-img(src="img/mla.png")
            v-card-actions
              v-spacer
              v-btn(color="green darken-1" flat="flat" @click="dialog = false") Close
        v-btn(v-if="$route.name !== 'Forex Request' && $route.name !== 'Document Legal F1' && $route.name !== 'Document Legal F2'" color='blue-secondary' to='/my-request') LIST MEMO
      WizardNonBudget(v-if="$route.path == '/create-memo'")
      WizardNonBudget(v-if="$route.path == '/internal-memo'")
</template>

<script>
import WizardNonBudget from "../components/WizardNonBudget.vue";
export default {
  name: "NewForm",
  components: {
    WizardNonBudget
  },
  data () {
    return {
      dialog: false
    }
  }
};
</script>